import { render, staticRenderFns } from "./PanelAddButton.vue?vue&type=template&id=181cd09e&"
import script from "./PanelAddButton.vue?vue&type=script&lang=js&"
export * from "./PanelAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports